import { Helpers } from '../../helpers';
import { IRigContract } from '../../interfaces/irig-contract';
import { Rig } from '../rig';
import { RigContractAmendment } from '../rig-contract-amendment';
import { RigContractStatus } from '../rig-contract-status';

export class RigContractBase {
  RigContractId: number;
  RigId: number;
  RigContractStatusId: number;
  ContractStart: Date;
  ContractEnd: Date;
  ReleasedTerminatedDate: Date | null;
  Contractor: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  RigContractAmendments_RigContract?: Array<RigContractAmendment> | null;
  RigContractStatus?: RigContractStatus;
  Rig?: Rig;

  constructor(item?: IRigContract) {
    if (item) {

      this.RigContractId = item.RigContractId;
      this.RigId = item.RigId;
      this.RigContractStatusId = item.RigContractStatusId;
      this.ContractStart = item.ContractStart ? new Date(item.ContractStart) : null;
      this.ContractEnd = item.ContractEnd ? new Date(item.ContractEnd) : null;
      this.ReleasedTerminatedDate = item.ReleasedTerminatedDate ? new Date(item.ReleasedTerminatedDate) : null;
      this.Contractor = item.Contractor;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.RigContractAmendments_RigContract = Helpers.createClassArray(RigContractAmendment, item.RigContractAmendments_RigContract);
      this.RigContractStatus = new RigContractStatus(item.RigContractStatus);
      this.Rig = new Rig(item.Rig);
    }
  }
}